define((require) => {
    "use strict";

    const _                   = require("underscore");
    const Effect              = require("shared/ui/experience/action/effects/EffectModel");

    const TYPE = "imageToggle";

    return Effect.extend({

        defaults: _.defaults({
            /**
             * @type {String}
             */
            type: TYPE,

            /**
             * The relative image source, e.g. <tt>assets/images/57a04e8ee4b05c37b56240c6.jpeg"</tt>.
             *
             * @type {String}
             */
            src: null,

            /**
             * @type {Number}
             */
            originalImageWidth: 0,

            /**
             * @type {Number}
             */
            originalImageHeight: 0,

            /**
             * Whether the associated image "supports resize", i.e. has resized representations on S3.
             *
             * @type {Boolean}
             */
            supportsResize: false,

            /**
             * Id of the associated image.
             *
             * @type {String}
             */
            imageId: null,

            /**
             * The image alt text.
             *
             * @type {String}
             */
            altText: null
        }, Effect.prototype.defaults),

        computed: {
            imageUrl: {
                deps: ["src"],
                value(src) {
                    return src;
                }
            }
        },

        /**
         * Whether *this* effect contains a valid original size of the associated image, if any.
         *
         * @return {Boolean} <tt>true</tt> if *this* effect contains a valid original size of the associated image, <tt>false</tt> otherwise.
         */
        containsImageSize() {
            return this.get("originalImageWidth") > 0 && this.get("originalImageHeight") > 0;
        }

    }, {
        TYPE
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/ImageToggleEffectModel.js